import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { STATUSES } from 'mixins/constants';
import { IFindTaxpayerServiceProps } from '../find-taxpayer-service.type';
import { getTaxPayerInfo } from '../actions';
import { filterDigits, localize, removeEmptyValues } from 'mixins/helpers';

const FindTaxpayerServiceJur = forwardRef((props: IFindTaxpayerServiceProps, ref) => {
    const { beginDate, endDate, statusName, organizationName } = props.config;
    const [form] = Form.useForm();
    const [status, setStatus] = useState<string>();

    const formValues = Form.useWatch([], form);

    // Effect to prevent stale validation errors when field
    // becomes optional depending on another field value
    useEffect(() => {
        form.validateFields();
    }, [formValues]);

    const onFinish = (values: any) => {
        props.setLoading(true);
        let formattedValues = removeEmptyValues(Object.assign(values, { type: props.type }));
        props.setValues(formattedValues);
        getTaxPayerInfo(formattedValues)
            .then((value) => {
                props.setTableData(value.data.taxpayers);
                props.setTotal(value.data.total);
            })
            .finally(() => props.setLoading(false));
    };

    const handleSelectChange = (value: string) => {
        setStatus(value);
    };

    useImperativeHandle(ref, () => ({
        clearForm() {
            form.resetFields();
            props.setTableData(null);
            props.setValues(null);
            props.setTotal(null);
        },
        searchForm() {
            form.submit();
        },
    }));

    return (
        <>
            <Form
                name="findTaxpayerJur"
                onFinish={onFinish}
                form={form}
                layout="vertical"
            >
                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            label={props.iinBinLabel(props.type)}
                            name="iinBin"
                            rules={[
                                {
                                    required: !formValues?.organizationName,
                                    message: localize(
                                        'error.field-is-required',
                                        props.translations
                                    ),
                                },
                                {
                                    min: 12,
                                    message: localize(
                                        'error.iin-bin-length-12',
                                        props.translations
                                    ),
                                },
                            ]}
                        >
                            <Input
                                onChange={filterDigits(form, 'iinBin')}
                                maxLength={12}
                                placeholder={localize(
                                    'placeholder.input',
                                    props.translations
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col
                        xs={24}
                        md={10}
                    >
                        <Form.Item
                            label={props.type === 'IP'
                                ? localize('ip-name', props.translations)
                                : organizationName}
                            name="organizationName"
                            rules={[
                                {
                                    required: !formValues?.iinBin,
                                    message: localize(
                                        'error.field-is-required',
                                        props.translations
                                    ),
                                },
                                {
                                    min: 3,
                                    message: localize(
                                        'error.unique-code-3',
                                        props.translations
                                    ),
                                },
                            ]}
                        >
                            <Input
                                placeholder={localize(
                                    'placeholder.input',
                                    props.translations
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </>
    );
});

export default FindTaxpayerServiceJur;
